import { queryOptions } from '@tanstack/react-query';

import { INDEX_PAGE } from './markdown/paths';

/**
 * The manual through TanStack Query, so a screen can wait for a page (or for the index) without
 * suspending: the side menu of the help sits above the content's suspense boundary, and a menu that
 * suspends blanks the whole screen (`PageOutlet`). `manualContent` is imported on demand, which is
 * what keeps the manual's text out of the console's main bundle. The text never changes while the
 * console is open, so it is never stale, and the parsed tree is kept as it is (no structural
 * sharing over a tree this size).
 */
export function manualIndexQueryOptions() {
  return queryOptions({
    queryKey: ['help', 'index'],
    queryFn: async () => (await import('./manualContent')).loadManualIndex(),
    staleTime: Infinity,
    gcTime: Infinity,
    structuralSharing: false,
    retry: false,
  });
}

export function manualPageQueryOptions(page: string) {
  return queryOptions({
    queryKey: ['help', 'page', page],
    queryFn: async () => (await import('./manualContent')).loadManualDocument(page),
    staleTime: Infinity,
    gcTime: Infinity,
    structuralSharing: false,
    retry: false,
  });
}

/** The page a help address names: `/ayuda` is the index, `/ayuda/<page>` any other. */
export function helpPageOfPath(pathname: string): string {
  const match = /^\/ayuda(?:\/(.+?))?\/?$/.exec(pathname);
  const page = match?.[1];
  return page === undefined || page === '' ? INDEX_PAGE : page;
}
